(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ledlenser-campaign-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ll-campaign-products')) {
    customElements.define('ll-campaign-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.layout !== 'carousel') return;
        this.track = this.querySelector('.ll-campaign-products__track');
        this.controls = this.querySelector('.ll-campaign-products__controls');
        this.abort = new AbortController();
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({left: Number(button.dataset.direction) * rtl * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal: this.abort.signal});
        this.track.addEventListener('scroll', () => this.updateControls(), {signal: this.abort.signal, passive: true});
        this.resize = new ResizeObserver(() => this.updateControls());
        this.resize.observe(this.track);
        this.updateControls();
      }
      updateControls() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = maximum < 2;
        this.controls.querySelector('[data-direction="-1"]').disabled = position < 2;
        this.controls.querySelector('[data-direction="1"]').disabled = position >= maximum - 2;
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ledlenser-expanded-navigation"] && !Shopify.designMode) return;
  try {
    const hoverTimers = new WeakMap();
  const hoverCategory = event => {
    if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover) and (pointer: fine)').matches || !(event.target instanceof Element)) return null;
    return event.target.closest('.ll-navigation--desktop .ll-mega-category');
  };
  document.addEventListener('pointerover', event => {
    const category = hoverCategory(event);
    if (!category) return;
    clearTimeout(hoverTimers.get(category));
    if (category.contains(event.relatedTarget)) return;
    for (const sibling of category.parentElement.querySelectorAll(':scope > details[open]')) if (sibling !== category) sibling.open = false;
    category.open = true;
  });
  document.addEventListener('pointerout', event => {
    const category = hoverCategory(event);
    if (!category || category.contains(event.relatedTarget)) return;
    hoverTimers.set(category, setTimeout(() => {
      if (!category.matches(':hover') && !category.contains(document.activeElement)) category.open = false;
    }, 180));
  });

  const syncMobileLevel = root => {
    const category = root.querySelector('.ll-mega-category[open]');
    const title = root.querySelector('.ll-mobile-title');
    title.textContent = category ? category.querySelector('summary > span:not(.ll-mega-icon)').textContent : title.dataset.menuTitle;
    root.querySelector('.ll-mobile-back').hidden = !category;
    root.querySelector('.ll-mobile-levels').scrollTop = 0;
  };
  const positionMobilePanel = root => {
    const panel = root.querySelector('.ll-navigation__items');
    const previousOffset = Number.parseFloat(root.style.getPropertyValue('--ll-mobile-top-offset')) || 0;
    root.style.setProperty('--ll-mobile-top-offset', (panel.getBoundingClientRect().top + previousOffset) + 'px');
  };
  window.addEventListener('resize', () => {
    for (const root of document.querySelectorAll('.ll-navigation--mobile .ll-navigation__mobile-toggle[open]')) {
      if (matchMedia('(min-width: 750px)').matches || root.closest('.ll-navigation--mobile').offsetParent === null) root.open = false;
      else positionMobilePanel(root);
    }
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const root = event.target.closest('.ll-navigation__mobile-toggle');
    if (root && event.target.closest('.ll-mobile-close')) {
      root.open = false;
      root.querySelector(':scope > summary').focus();
    }
    if (root && event.target.closest('.ll-mobile-back')) {
      const category = root.querySelector('.ll-mega-category[open]');
      if (category) { category.open = false; syncMobileLevel(root); category.querySelector('summary').focus(); }
    }
    if (root && event.target.closest('a[href]')) root.open = false;
    for (const navigation of document.querySelectorAll('.ll-navigation')) if (!navigation.contains(event.target)) for (const item of navigation.querySelectorAll('details[open]')) item.open = false;
  });
  document.addEventListener('toggle', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLDetailsElement)) return;
    const mobileRoot = target.closest('.ll-navigation__mobile-toggle');
    if (mobileRoot) {
      syncMobileLevel(mobileRoot);
      if (target === mobileRoot && target.open) { positionMobilePanel(mobileRoot); mobileRoot.querySelector('.ll-mobile-close').focus(); }
      if (target === mobileRoot && !target.open) for (const category of mobileRoot.querySelectorAll('.ll-mega-category[open]')) category.open = false;
      if (target.classList.contains('ll-mega-category') && target.open) mobileRoot.querySelector('.ll-mobile-back').focus();
    }
    if (!target.open || !target.classList.contains('ll-mega-category')) return;
    for (const sibling of target.parentElement.querySelectorAll(':scope > details[open]')) if (sibling !== target) sibling.open = false;
  }, true);
  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) return;
    const mobileRoot = event.target.closest('.ll-navigation__mobile-toggle[open]');
    if (mobileRoot && event.key === 'Tab') {
      const elements = [...mobileRoot.querySelectorAll('button, a[href], summary')].filter(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && element !== mobileRoot.querySelector(':scope > summary'));
      const first = elements[0], last = elements.at(-1);
      if (event.shiftKey && event.target === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && event.target === last) { event.preventDefault(); first?.focus(); }
    }
    if (event.key !== 'Escape') return;
    if (mobileRoot) {
      event.preventDefault();
      const category = mobileRoot.querySelector('.ll-mega-category[open]');
      if (category) { category.open = false; syncMobileLevel(mobileRoot); category.querySelector('summary').focus(); }
      else { mobileRoot.open = false; mobileRoot.querySelector(':scope > summary').focus(); }
      return;
    }
    const detail = event.target.closest('.ll-navigation details[open]');
    if (detail) { detail.open = false; detail.querySelector('summary')?.focus(); }
  });
  document.addEventListener('shopify:block:select', (event) => {
    const id = event.detail?.blockId;
    for (const category of document.querySelectorAll('.ll-mega-category')) {
      if (category.closest('.ll-navigation')?.offsetParent === null) continue;
      const selected = category.dataset.megaCategory === id || category.querySelector('[data-shopify-editor-block*="' + id + '"]');
      if (selected) { category.open = true; const mobile = category.closest('.ll-navigation__mobile-toggle'); if (mobile) mobile.open = true; }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
